// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/icing-effects-on-stall.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/icing-effects-on-stall/icing-effects-on-stall.js';

mount([g0]);
